import Link from '@tiptap/extension-link'

/**
 * Enhanced Link Extension
 * Simple extension to handle URLs with paths, query params, and fragments
 */
const EnhancedLink = Link.extend({
  addPasteRules() {
    return [
      {
        find: (text) => {
          const urlRegex =
            /(?:https?:\/\/)?(?:www\.)?[\w\-]+\.[\w\-]+(\.[\w\-]+)*([\w\-\.\/?&=#%+]*)/gi

          const matches = []
          const allMatches = [...text.matchAll(urlRegex)]

          for (const match of allMatches) {
            let url = match[0]

            if (!url.includes('.')) continue

            url = url.replace(/[,;:!?\)\]]+$/, '')

            let href = url
            if (!href.startsWith('http://') && !href.startsWith('https://')) {
              href = `https://${href}`
            }

            matches.push({
              text: url,
              index: match.index,
              data: { href },
            })
          }

          return matches
        },

        handler: ({ state, range, match, chain }) => {
          const url = match.data.href

          chain()
            .setTextSelection({ from: range.from, to: range.to })
            .setLink({ href: url, target: '_blank' })
            .setTextSelection(range.to)
            .run()
        },
      },
    ]
  },
})

export default EnhancedLink
